import React, { useState } from 'react';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Popover } from '@uhg-abyss/web/ui/Popover';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { loggedInAdvocateAtom, memberInContextAtom } from '@src/global-state';
import { useAtom } from 'jotai';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';

export const Header = () => {
  const [loggedInAdvocate, setLoggedInAdvocate] = useAtom(loggedInAdvocateAtom);
  const [memberInContext, setMemberInContext] = useAtom(memberInContextAtom);
  const [isOpen, setIsOpen] = useState(false);
  const { navigate } = useRouter();

  const goToMyFavorites = async () => {
    navigate('/my-favorites');
  };

  return (
    <div
      className="noPrint"
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ marginLeft: '5.5%' }}>
        <Brandmark
          brand="uhc"
          size="$sm"
          affiliate="uhc"
          variant="lockup"
          color="white"
        />
      </div>

      <div
        style={{
          marginRight: '5%',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <Heading size="sm" color="$core.color.neutral.0" style={{ margin: 0 }}>
          UHC Community Connector
        </Heading>
        <Popover
          showClose={false}
          open={isOpen}
          onOpenChange={() => setIsOpen(!isOpen)}
          width="300"
          heading={
            <Text color="$core.color.brand.100" fontWeight="bold">
              Hi, {loggedInAdvocate?.first_name} {loggedInAdvocate?.last_name}
            </Text>
          }
          content={
            <>
              {memberInContext?.member_id && (
                <div
                  data-cy="my-favorites-link"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'left',
                    paddingTop: '10px',
                    paddingBottom: '10px',
                  }}
                >
                  <IconSymbol
                    icon="favorite"
                    style={{ paddingRight: '5px', marginRight: '10px' }}
                    color="$core.color.brand.100"
                    size="xs"
                  />
                  <Text
                    style={{ cursor: 'pointer' }}
                    fontWeight="bold"
                    color="$core.color.brand.100"
                    href="/my-favorites"
                    onClick={() => {
                      setIsOpen(!isOpen);
                      return goToMyFavorites();
                    }}
                  >
                    My Favorites
                  </Text>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  data-cy="log-out-button"
                  href="/logout"
                  size="$sm"
                  variant="outline"
                  style={{ width: '150px', margin: '10px 0' }}
                >
                  Log out
                </Button>
              </div>
            </>
          }
          position="bottom"
        >
          <IconSymbol data-cy="hamburger-menu" icon="menu" color="$core.color.neutral.1" />
        </Popover>
      </div>
    </div>
  );
};
